import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../services/api';
import sal from 'sal.js';
import './DoctorProfile.css';

import Profile from './partials/Profile';
import About from './partials/About';
import AwardsRecognitions from './partials/AwardsRecognitions';
import Learning from './partials/Learning';
import ResearchPublications from './partials/ResearchPublications';
import Service from './partials/Service';
import FaqSection from '../home/partials/FaqSection';
import VideosSection from '../home/partials/VideosSection';

const DoctorProfile = () => {
  const { slug } = useParams();
  const [doctorData, setDoctorData] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDoctorData = async () => {
      setLoading(true);
      try {
        const [response, faqsRes] = await Promise.all([
          api.get(`/api/doctors/profile/${slug}`),
          api.get(`/api/faqs/screen/${slug}`),
        ]);
        setDoctorData(response.data);
        setFaqs(faqsRes.data);
      } catch (err) {
        console.error("Error fetching doctor:", err);
        setError("Doctor not found.");
      } finally {
        setLoading(false);
      }
    };

    if (slug) fetchDoctorData();
  }, [slug]);

  useEffect(() => {
    if (doctorData) {
      setTimeout(() => sal({ threshold: 0.2, once: true }), 300);
    }
  }, [doctorData]);

  const DoctorProfileSkeleton = () => (
    <>
      <div className="doctor-profile-wrapper py-5 mt-lg-3">
        <div className="container">
          <div className="row px-lg-5">
            <div className="col-lg-4 mb-4 mb-lg-0">
              <div
                className="skeleton shimmer"
                style={{ height: "320px", borderRadius: "16px" }}
              ></div>
            </div>
            <div className="col-lg-8">
              <div className="skeleton">
                <div className="skeleton-line medium shimmer"></div>
                <div className="skeleton-line short shimmer"></div>
                <div className="row mt-3">
                  {[1, 2, 3].map((i) => (
                    <div className="col-md-6 mb-2" key={i}>
                      <div className="skeleton-line medium shimmer"></div>
                    </div>
                  ))}
                </div>
                <div className="skeleton-line long shimmer mt-3"></div>
                <div
                  className="skeleton shimmer mt-4"
                  style={{ width: "220px", height: "46px", borderRadius: "30px" }}
                ></div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <section className="doctor-profile-about-section">
        <div className="container py-5">
          <div className="skeleton text-center">
            <div className="skeleton-line medium shimmer mx-auto"></div>
            <div className="skeleton-line long shimmer mx-auto"></div>
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="skeleton-line long shimmer"></div>
            ))}
          </div>
          <div
            className="skeleton shimmer mt-4"
            style={{ width: "100%", height: "250px", borderRadius: "16px" }}
          ></div>
        </div>
      </section>
    </>
  );

  if (loading) return <DoctorProfileSkeleton />;
  if (error) return <div>{error}</div>;
  if (!doctorData) return null;

  return (
    <>
      <Profile name={doctorData.name} profile={doctorData.profile} />
      {doctorData.about && <About aboutData={doctorData.about} doctorName={doctorData.name} />}
      {doctorData.learning && <Learning data={doctorData.learning} />}
      {doctorData.awards && <AwardsRecognitions data={doctorData.awards} />}
      {doctorData.services && <Service data={doctorData.services} />}
      {doctorData.research && <ResearchPublications data={doctorData.research} doctorName={doctorData.name} />}
      {faqs.length > 0 && <FaqSection faqs={faqs} />}
      <VideosSection />
    </>
  );
};

export default DoctorProfile;